import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/treynor-ratio-calculator',
  component: () => import('../../routes/TreynorRatioCalculator.svelte'),
  card: {
    id: 'treynor-ratio',
    title: 'Treynor Ratio',
    description: 'Measure risk-adjusted returns per unit of systematic risk (beta) — ideal for evaluating diversified portfolio performance.',
    icon: 'swap_vert',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/treynor-ratio-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Treynor Ratio Calculator – Risk-Adjusted Return Per Unit of Systematic Risk',
    description: 'Free Treynor Ratio calculator measures portfolio performance relative to market risk. Compare investments using beta-adjusted excess returns.',
  },
};

export default meta;
